<template>
	<div>
		<div class="handleBars">
			<div>
				<el-button type="primary" @click="createCompany">创建公司</el-button>
			</div>
			<div>
				<div class="handleBarItem">
					<span>问卷名称</span>
					<el-input v-model="filters.companyName" placeholder="公司名称" style="width: 280px;" />
				</div>
				<el-button @click="search" type="primary">查询</el-button>
			</div>
		</div>
		<el-table :data="companyList" stripe style="width: 100%">
			<el-table-column prop="companyName" label="公司名称" />
			<el-table-column prop="industry" label="行业" />
			<el-table-column label="规模">
				<template slot-scope="scope">
					{{ getScaleLabel(scope.row.scale) }}
				</template>
			</el-table-column>
			<el-table-column prop="jobCount" label="岗位数" />
			<el-table-column prop="openJobCount" label="在招岗位" />
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="editCompany(scope.row)">编辑</el-button>
					<el-button type="text" @click="deleteCompany(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination
			@current-change="handlePageChange"
			:current-page="pagination.pageNum"
			:page-size="pagination.pageSize"
			:total="pagination.total"
			layout="prev, pager, next"
		/>
		<CompanyCreateEditDialog v-model="showDialog" :company="editingCompany" @confirm="onConfirm" />
	</div>
</template>

<script>
import { companyRecruit } from "@/services";
import CompanyCreateEditDialog from "@/components/recruit/CompanyCreateEditDialog.vue";

export default {
	name: "CompanyManage",
	components: {
		CompanyCreateEditDialog,
	},
	data() {
		return {
			filters: {
				companyName: "",
			},
			companyList: [],
			pagination: {
				pageNum: 1,
				pageSize: 10,
				total: 0,
			},
			showDialog: false,
			editingCompany: {},
			scaleOptions: [
				{ label: "0-20人", value: 0 },
				{ label: "20-99人", value: 1 },
				{ label: "100-499人", value: 2 },
				{ label: "500-999人", value: 3 },
				{ label: "1000-9999人", value: 4 },
				{ label: "10000人以上", value: 5 },
			],
		};
	},
	mounted() {
		this.fetchCompanies();
	},
	methods: {
		async fetchCompanies() {
			const params = {
				pageNum: this.pagination.pageNum,
				pageSize: this.pagination.pageSize,
				companyName: this.filters.companyName,
			};
			const { data, ok } = await companyRecruit.pageList(params);
			if (ok) {
				this.companyList = data.data.list || [];
				this.pagination.total = data.data.total || 0;
			}
		},
		search() {
			this.pagination.pageNum = 1;
			this.fetchCompanies();
		},
		createCompany() {
			this.editingCompany = {};
			this.showDialog = true;
		},
		onConfirm() {
			this.search();
		},
		editCompany(company) {
			this.editingCompany = company;
			this.showDialog = true;
		},
		async deleteCompany(company) {
			if (company.jobCount) {
				return this.$alert(`公司已关联${company.jobCount}个岗位，请先删除岗位后再删除企业`, "无法删除").catch(
					() => {}
				);
			}
			this.$confirm(`确定删除公司 "${company.companyName}" 吗？`, "删除公司", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(async () => {
					try {
						const { ok } = await companyRecruit.deleteCompany(company.id);
						if (ok) {
							this.$message.success("删除成功");
							this.search();
						}
					} catch (err) {
						console.error("删除失败", err);
						this.$message.error("删除失败");
					}
				})
				.catch(() => {
					// 取消
				});
		},
		handlePageChange(page) {
			this.pagination.pageNum = page;
			this.fetchCompanies();
		},
		getScaleLabel(scale) {
			const option = this.scaleOptions.find((opt) => opt.value === scale);
			return option ? option.label : scale;
		},
	},
};
</script>

<style scoped>
.top-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
}
.filter-bar {
	display: flex;
	align-items: center;
}
</style>
